/* tslint:disable */

export class Variable {
		Id: number;
		Key: string;
		QuestionId: number;
		ValueQuestionId: number;
		ValueDecisionId: number;
		ValueIntermediateBusinessDataId: number;

}



// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/Variable.ts